import { render } from "./ShopsView.vue?vue&type=template&id=0f85b9a7"
import script from "./ShopsView.vue?vue&type=script&lang=js"
export * from "./ShopsView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Gerente de TI\\Downloads\\temp\\JB\\new-project\\jb-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__